<template>
  <el-dialog :visible.sync="dialog" width="60%" :destroy-on-close="true" top="10vh" :before-close="closeHandle" :close-on-click-modal="false">
    <el-row type="flex" justify="center">
      <el-col :span="24" class="container">
        <el-row>
          <el-col>
            <el-select v-model="auditInfo.pass" placeholder="请选择审核结果" style="width:100%" @change="selectChangeHandle">
              <el-option v-for="item in passOptions" :key="item.key" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="row-m-top">
          <el-col>
            <el-input
              id="suggest"
              style="width:100%"
              type="textarea"
              placeholder="请输入审核意见"
              v-model="auditInfo.suggest"
              :autosize="{ minRows: 10, maxRows: 20}"
              maxlength="200"
              show-word-limit
            />
          </el-col>
        </el-row>
        <el-row class="row-m-top">
          <el-col>
            <el-button style="width:100%" type="primary" :disabled="notAllowSubmit||disable" icon="el-icon-s-promotion" @click="submit()">提交</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-dialog>
</template>
<style scoped>
.container {
  padding: 10px;
  margin-bottom: 5px 10px 20px;
}
.row-m-top {
  margin-top: 1.25rem;
}
</style>
<script>
import qs from 'qs';
export default {
  name: 'auditInfo',
  data () {
    return {
      auditInfo: {
        id: '',
        suggest: '',
        pass: null
      },
      passOptions: [
        { key: 1, value: true, label: '通过' },
        { key: 2, value: false, label: '不通过' }
      ],
      disable: false,
      dialog: false
    };
  },
  computed: {
    notAllowSubmit () {
      // 如果是通过，那么可以提交
      if (this.auditInfo.pass) return false;
      // 如果是不通过并且有理由 可以提交
      if (this.auditInfo.suggest) return false;
      // 否者禁用不让提交
      return true;
    }
  },
  methods: {
    /** 入口 */
    openHandle ({ id }) {
      if (id) {
        this.auditInfo.id = id
        this.dialog = true;
      } else {
        this.$message.warning('参数获取失败')
      }
    },
    // 查看按钮
    select (row) {
      this.dialog = true;
    },
    // 提交审核结果
    submit () {
      if (!this.auditInfo.pass && !this.auditInfo.suggest) {
        this.$message.warning('审核不通过需要填写，不通过理由或意见');
        return;
      }
      this.disable = true;
      this.$nstand.ajax(
        {
          url: '/api/Expert/Audit',
          method: 'post',
          data: qs.stringify(this.auditInfo),
          headers: {
            "content-type": 'application/x-www-form-urlencoded'
          },
          success: e => {
            const { success, message, data } = e.data
            if (success) {
              this.$message.success('操作成功');
              this.$emit('search')
              this.dialog = false;
            } else {
              this.$message.warning(e.data.message || '操作失败');
            }
          },
        },
        true
      ).then(() => {
        this.disable = false;
      });
    },
    /// 选择框改变选项，如果是不通过就需要将光标定到审核意见上
    selectChangeHandle (value) {
      if (!value) {
        this.$nextTick(() => {
          document.getElementById('suggest').focus();
        });
      }
    },
    closeHandle () {
      this.auditInfo.id = '';
      this.auditInfo.suggest = '';
      this.auditInfo.pass = null;
      this.dialog = false;
    }
  },
};
</script>
